import Avatar from "@amzn/awsui-chat-components-console/avatar";
import ChatBubble from "@amzn/awsui-chat-components-console/chat-bubble";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';
import { Message } from "../../../context/chatbot/ChatbotContext";

import './ChatbotMessages.scss';

const UserMessage = ({ message }: { message: Message }) => (
    <div data-testid="chatbot-user-message">
    <ChatBubble
        key={message.id}
        type="outgoing"
        ariaLabel={getString('chatbot.ariaLabels.userMessage')}
        avatar={<Avatar ariaLabel={getString('chatbot.ariaLabels.userAvatar')} iconName="user-profile" />}
    >
        <div className="chatbot-message-content">{message.text}</div>
    </ChatBubble>
    </div>
);

export default UserMessage;
